import { render, staticRenderFns } from "./kc-xy-show.vue?vue&type=template&id=2c5e7bf2&scoped=true"
import script from "./kc-xy-show.vue?vue&type=script&lang=js"
export * from "./kc-xy-show.vue?vue&type=script&lang=js"
import style0 from "./kc-xy-show.vue?vue&type=style&index=0&id=2c5e7bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e7bf2",
  null
  
)

export default component.exports